<template>
  <div
    class="boxcontent-item"
    @click="select"
  >
    <i class="far fa-file"></i>
    <p class="boxcontent-item-description">{{product.name}}</p>
  </div>
</template>

<script>
export default {
  props: {
    product: Object
  },
  methods: {
    select() {
      this.$emit("select", this.product);
    }
  }
};
</script>